<template>
  <div class="grid-column-start-2_md grid-column-end-4_md flex flex-column justify-items-center vh75">
    <header class="mb2 mt-margin">
      <h1 class="font-size-8 mb2">What are your project&nbsp;roles?</h1>
      <h2>What project roles or phases does your organization use to estimate?</h2>
      <p class="font-size-4">For example: Design, Development, Project Management. You can change these later.</p>
      <p class="font-size-4">You need to add at least one role.</p>
    </header>
    <section class="roles-list mb2 accent-text">
      <div
        v-for="role in roles"
        :key="role.id">
        <p class="display font-size-5 bold smoothing">{{ role.name }}</p>
      </div>
    </section>
    <form
      class="flex_sm flex-end justify-content-space-between align-items-flex-end mb2"
      @submit.prevent="addRole">
      <lw-text-input
        v-validate.disable="'required'"
        ref="role"
        :id="'role'"
        :name="'role'"
        :placeholder="'e.g. Design'"
        v-model="name"
        :error="errors.first('role')"
        :size="'large c1'"/>
      <div><button
        class="button large-button right full-button_mb mb2"
        type="submit">Add&nbsp;role</button></div>
    </form>
    <div class="flex justify-content-flex-end align-items-center align-baseline mb-margin">
      <div><button
        :class="roles.length < 1 ? 'disabled disabled-button' : 'accent-button'"
        :disabled="roles.length < 1"
        class="large-button "
        @click="$router.push({ name: 'addTeam' })">Next</button></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TextInput from '../../livewires/TextInput'
import * as firebase from 'firebase'
import sync from '../../mixins/sync'

export default {
  components: {
    lwTextInput: TextInput
  },
  mixins: [ sync ],
  data () {
    return {
      name: ''
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'organization',
      'roles'
    ])
  },
  mounted () {
    this.$refs.role.$el.children[0].focus()
  },
  methods: {
    addRole () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const updated = firebase.default.firestore.FieldValue.serverTimestamp()
          this.$store.dispatch('saveState', false)
          const payload = {
            name: this.name,
            owner: this.user.id,
            organization: this.user.selectedOrganization,
            created: updated,
            updated: updated,
            archived: false
          }
          this.$store.dispatch('addRole', payload)
          this.name = ''
          this.$refs.role.$el.children[0].focus()
        }
      })
    }
  }
}
</script>

<style scoped>
  .mb2 {
    margin-bottom: var(--line);
  }
</style>
